export class TvSearchSymbolResultItem {
}
